export default __webpack_public_path__ + "static/media/success.a9eb6caf.svg";